export const timeZonesLocales: Record<string, string> = {
	'Africa/Addis_Ababa': 'am-ET',
	'Africa/Algiers': 'en-GB',
	'America/Argentina/La_Rioja': 'es-AR',
	'America/Argentina/Rio_Gallegos': 'es-AR',
	'America/Argentina/San_Juan': 'es-AR',
	'America/Argentina/San_Luis': 'es-AR',
	'America/Boa_Vista': 'pt-BR',
	'America/Buenos_Aires': 'es-AR',
	'America/Campo_Grande': 'pt-BR',
	'Atlantic/Faeroe': 'en-GB',
	'America/Sao_Paulo': 'pt-BR',
	'America/St_Johns': 'fr-CA',
	'Asia/Colombo': 'hi-IN',
	'Asia/Kabul': 'fa-AF',
	'Asia/Kuala_Lumpur': 'ms-MY',
	'America/Havana': 'id-ID',
	'America/La_Paz': 'es-BO',
	'America/Miquelon': 'id-ID',
	'America/Porto_Velho': 'pt-BR',
	'America/Rio_Branco': 'pt-BR',
	'Africa/Addis-Ababa': 'en-US',
	'Africa/Blantyre': 'en-MW',
	'Africa/Cairo': 'en-GB',
	'Africa/Ceuta': 'en-GB',
	'Africa/Dar-es-Salaam': 'en-US',
	'Africa/El-Aaiun': 'en-US',
	'Africa/Gaborone': 'en-BW',
	'Africa/Harare': 'en-ZW',
	'Africa/Johannesburg': 'en-ZA',
	'Africa/Juba': 'en-SS',
	'Africa/Kampala': 'en-UG',
	'Africa/Lagos': 'en-NG',
	'Africa/Lusaka': 'en-ZM',
	'Africa/Maseru': 'en-LS',
	'Africa/Mbabane': 'en-SZ',
	'Africa/Nairobi': 'en-KE',
	'Africa/Sao-Tome': 'en-US',
	'Africa/Tripoli': 'en-GB',
	'Africa/Tunis': 'en-GB',
	'Africa/Windhoek': 'en-NA',
	'America/Araguaina': 'pt-BR',
	'America/Argentina/Catamarca': 'es-AR',
	'America/Argentina/ComodRivadavia': 'es-AR',
	'America/Argentina/Cordoba': 'es-AR',
	'America/Argentina/Jujuy': 'es-AR',
	'America/Argentina/Mendoza': 'es-AR',
	'America/Argentina/Salta': 'es-AR',
	'America/Argentina/Tucuman': 'es-AR',
	'America/Argentina/Ushuaia': 'es-AR',
	'America/Bahia': 'pt-BR',
	'America/Belem': 'pt-BR',
	'America/Bogota': 'es-CO',
	'America/Caracas': 'es-VE',
	'America/Catamarca': 'es-AR',
	'America/Cayenne': 'fr-GF',
	'America/Cordoba': 'es-AR',
	'America/Cuiaba': 'pt-BR',
	'America/Eirunepe': 'pt-BR',
	'America/Fortaleza': 'pt-BR',
	'America/Guayaquil': 'es-EC',
	'America/Guyana': 'en-GY',
	'America/Jujuy': 'es-AR',
	'America/Lima': 'es-PE',
	'America/Maceio': 'pt-BR',
	'America/Manaus': 'pt-BR',
	'America/Mendoza': 'es-AR',
	'America/Montevideo': 'es-UY',
	'America/Paramaribo': 'nl-SR',
	'America/Recife': 'pt-BR',
	'America/Rosario': 'es-AR',
	'America/Santarem': 'pt-BR',
	'America/Santiago': 'es-CL',
	'Antarctica/South-Pole': 'en-US',
	'Arctic/Longyearbyen': 'en-GB',
	'Asia/Beirut': 'en-GB',
	'Asia/Calcutta': 'hi-IN',
	'Asia/Dubai': 'ar-SA',
	'Asia/Gaza': 'en-GB',
	'Asia/Hebron': 'en-GB',
	'Asia/Ho-Chi-Minh': 'en-US',
	'Asia/Hong-Kong': 'en-US',
	'Asia/Jakarta': 'id-ID',
	'Asia/Jayapura': 'id-ID',
	'Asia/Kolkata': 'hi-IN',
	'Asia/Kuala-Lumpur': 'en-US',
	'Asia/Kuching': 'ms-MY',
	'Asia/Makassar': 'id-ID',
	'Asia/Muscat': 'ar-SA',
	'Asia/Nicosia': 'en-GB',
	'Asia/Pontianak': 'id-ID',
	'Asia/Singapore': 'ms-SG',
	'Asia/Tehran': 'fa-IR',
	'Asia/Tel-Aviv': 'en-US',
	'Asia/Tokyo': 'ja-JP',
	'Asia/Ujung-Pandang': 'en-US',
	'Atlantic/Azores': 'pt-PT',
	'Atlantic/Canary': 'en-GB',
	'Atlantic/Madeira': 'en-GB',
	'Australia/Broken-Hill': 'en-US',
	'Australia/Lord-Howe': 'en-US',
	CET: 'en-GB',
	'Canada/Newfoundland': 'fr-CA',
	'Chile/Continental': 'es-CL',
	Cuba: 'id-ID',
	EET: 'en-GB',
	Egypt: 'en-GB',
	Eire: 'en-IE',
	'Europe/Dublin': 'en-IE',
	'Europe/Isle-of-Man': 'en-US',
	'Europe/San-Marino': 'en-US',
	GB: 'en-GB',
	'GB-Eire': 'en-GB',
	Iran: 'fa-IR',
	Japan: 'ja-JP',
	Libya: 'en-GB',
	MET: 'en-GB',
	NZ: 'en-NZ',
	'NZ-CHAT': 'en-NZ',
	'Pacific/Auckland': 'en-NZ',
	'Pacific/Chatham': 'en-NZ',
	'Pacific/Guam': 'en-GU',
	Poland: 'en-GB',
	Portugal: 'en-GB',
	Singapore: 'en-SG',
	WET: 'en-GB',
};

export const regionsLocales: Record<string, string> = {
	America: 'en-US',
	Europe: 'en-GB',
	Atlantic: 'en-US',
	Australia: 'en-AU',
	Antarctica: 'en-AU',
	Brazil: 'pt-BR',
	Canada: 'en-US',
	Mexico: 'en-US',
	Pacific: 'en-US',
	US: 'en-US',
};
